import type { RedcatAnalyticsStore } from '../types/store';
import { OAuthTrackEventName } from '../types/oauth';
import type { OAuthProvider } from '../types/oauth';
import type { OAuthTrackEvent } from '../types/events/track';

export const trackOAuthProviderAuthenticated = (
  track: RedcatAnalyticsStore['track'],
  { provider }: { provider: OAuthProvider },
) => {
  const event: OAuthTrackEvent = {
    name: OAuthTrackEventName.ProviderAuthenticated,
    properties: {
      provider,
    },
  };

  track(event);
};
